import { TranslateService } from '@project/translate';

export enum EReferralGuideSpecializationDTO {
  Infectologist = 'Infectologista',
  GeneralPhysician = 'Clínico Geral',
  Pulmonologist = 'Pneumologista',
  Cardiologist = 'Cardiologista',
  Intensivist = 'Intensivista',
  Dermatologist = 'Dermatologista',
  Physiotherapist = 'Fisioterapeuta',
  Psychologist = 'Psicólogo',
  Psychiatrist = 'Psiquiatra',
  VascularSurgeon = 'Cirurgião Vascular',
  Endocrinologist = 'Endocrinologista',
  Gastroenterologist = 'Gastroenterologista',
  Gynecologist = 'Ginecologista',
  Obstetric = 'Obstetra',
  Hematologist = 'Hematologista',
  Nephrologist = 'Nefrologista',
  Neurologist = 'Neurologista',
  Nutritionist = 'Nutricionista',
  Ophthalmologist = 'Oftalmologista',
  Orthopedist = 'Ortopedista',
  Otolaryngologist = 'Otorrinolaringologista',
  Pediatrician = 'Pediatra',
  ChildPsychiatrist = 'Psiquiatra Infantil',
  Rheumatologist = 'Reumatologista',
  Traumatologist = 'Traumatologista',
  Urologist = 'Urologista',
  GeneralSurgeon = 'Cirurgião Geral',
  ChildNeurologist = 'Neurologista Infantil',
  ChildPsychologist = 'Psicólogo Infantil',
  Geriatrician = 'Geriatria',
  Hepatology = 'Hepatologia',
  Allergology = 'Alergologia',
  AllergyAndImmunology = 'Alergia e Imunologia',
  Anesthesiology = 'Anestesiologia',
  Angiology = 'Angiologia',
  CardiovascularSurgery = 'Cirurgia Cardiovascular',
  HandSurgery = 'Cirurgia da Mão',
  DigestiveSystemSurgery = 'Cirurgia do Aparelho Digestivo',
  OncologicSurgery = 'Cirurgia Oncológica',
  PediatricSurgery = 'Cirurgia Pediátrica',
  PlasticSurgery = 'Cirurgia Plástica',
  ThoracicSurgery = 'Cirurgia Torácica',
  Coloproctology = 'Coloproctologia',
  MedicalGenetics = 'Genética Médica',
  Mastology = 'Mastologia',
  FamilyAndCommunityMedicine = 'Medicina de Família e Comunidade',
  OccupationalMedicine = 'Medicina do Trabalho',
  TrafficMedicine = 'Medicina do Tráfego',
  SportsMedicine = 'Medicina Esportiva',
  PhysicalAndRehabilitationMedicine = 'Medicina Física e Reabilitação',
  LegalAndForensicMedicine = 'Medicina Legal e Perícia Médica',
  NuclearMedicine = 'Medicina Nuclear',
  PreventiveAndSocialMedicine = 'Medicina Preventiva e Social',
  Neonatology = 'Neonatologia',
  Neurosurgery = 'Neurocirurgia',
  Nutrology = 'Nutrologia',
  ClinicalOncology = 'Oncologia Clínica',
  Pathology = 'Patologia',
  ClinicalPathologyAndLaboratoryMedicine = 'Patologia Clínica / Medicina Laboratorial',
  Radiology = 'Radiodiagnóstico',
  Radiotherapy = 'Radioterapia',
  SpeechTherapist = 'Fonoaudiólogo',
  OccupationalTherapist = 'Terapeuta Ocupacional',
  Nurse = 'Enfermeiro',
  SocialWorker = 'Assistente Social',
  Pharmacist = 'Farmacêutico',
  Dentist = 'Cirurgião-Dentista',
}

export function getReferralGuideSpecialization(specialization: EReferralGuideSpecializationDTO): string | undefined {
  const map: Record<EReferralGuideSpecializationDTO, () => string> = {
    [EReferralGuideSpecializationDTO.Infectologist]: () =>
      TranslateService.localize('referral-guide.specialization.infectologist'),
    [EReferralGuideSpecializationDTO.GeneralPhysician]: () =>
      TranslateService.localize('referral-guide.specialization.general-physician'),
    [EReferralGuideSpecializationDTO.Pulmonologist]: () =>
      TranslateService.localize('referral-guide.specialization.pulmonologist'),
    [EReferralGuideSpecializationDTO.Cardiologist]: () =>
      TranslateService.localize('referral-guide.specialization.cardiologist'),
    [EReferralGuideSpecializationDTO.Intensivist]: () =>
      TranslateService.localize('referral-guide.specialization.intensivist'),
    [EReferralGuideSpecializationDTO.Dermatologist]: () =>
      TranslateService.localize('referral-guide.specialization.dermatologist'),
    [EReferralGuideSpecializationDTO.Physiotherapist]: () =>
      TranslateService.localize('referral-guide.specialization.physiotherapist'),
    [EReferralGuideSpecializationDTO.Psychologist]: () =>
      TranslateService.localize('referral-guide.specialization.psychologist'),
    [EReferralGuideSpecializationDTO.Psychiatrist]: () =>
      TranslateService.localize('referral-guide.specialization.psychiatrist'),
    [EReferralGuideSpecializationDTO.VascularSurgeon]: () =>
      TranslateService.localize('referral-guide.specialization.vascular-surgeon'),
    [EReferralGuideSpecializationDTO.Endocrinologist]: () =>
      TranslateService.localize('referral-guide.specialization.endocrinologist'),
    [EReferralGuideSpecializationDTO.Gastroenterologist]: () =>
      TranslateService.localize('referral-guide.specialization.gastroenterologist'),
    [EReferralGuideSpecializationDTO.Gynecologist]: () =>
      TranslateService.localize('referral-guide.specialization.gynecologist'),
    [EReferralGuideSpecializationDTO.Obstetric]: () =>
      TranslateService.localize('referral-guide.specialization.obstetric'),
    [EReferralGuideSpecializationDTO.Hematologist]: () =>
      TranslateService.localize('referral-guide.specialization.hematologist'),
    [EReferralGuideSpecializationDTO.Nephrologist]: () =>
      TranslateService.localize('referral-guide.specialization.nephrologist'),
    [EReferralGuideSpecializationDTO.Neurologist]: () =>
      TranslateService.localize('referral-guide.specialization.neurologist'),
    [EReferralGuideSpecializationDTO.Nutritionist]: () =>
      TranslateService.localize('referral-guide.specialization.nutritionist'),
    [EReferralGuideSpecializationDTO.Ophthalmologist]: () =>
      TranslateService.localize('referral-guide.specialization.ophthalmologist'),
    [EReferralGuideSpecializationDTO.Orthopedist]: () =>
      TranslateService.localize('referral-guide.specialization.orthopedist'),
    [EReferralGuideSpecializationDTO.Otolaryngologist]: () =>
      TranslateService.localize('referral-guide.specialization.otolaryngologist'),
    [EReferralGuideSpecializationDTO.Pediatrician]: () =>
      TranslateService.localize('referral-guide.specialization.pediatrician'),
    [EReferralGuideSpecializationDTO.ChildPsychiatrist]: () =>
      TranslateService.localize('referral-guide.specialization.child-psychiatrist'),
    [EReferralGuideSpecializationDTO.Rheumatologist]: () =>
      TranslateService.localize('referral-guide.specialization.rheumatologist'),
    [EReferralGuideSpecializationDTO.Traumatologist]: () =>
      TranslateService.localize('referral-guide.specialization.traumatologist'),
    [EReferralGuideSpecializationDTO.Urologist]: () =>
      TranslateService.localize('referral-guide.specialization.urologist'),
    [EReferralGuideSpecializationDTO.GeneralSurgeon]: () =>
      TranslateService.localize('referral-guide.specialization.generalsurgeon'),
    [EReferralGuideSpecializationDTO.ChildNeurologist]: () =>
      TranslateService.localize('referral-guide.specialization.childNeurologist'),
    [EReferralGuideSpecializationDTO.ChildPsychologist]: () =>
      TranslateService.localize('referral-guide.specialization.childPsychologist'),
    [EReferralGuideSpecializationDTO.Geriatrician]: () =>
      TranslateService.localize('referral-guide.specialization.geriatrician'),
    [EReferralGuideSpecializationDTO.Hepatology]: () =>
      TranslateService.localize('referral-guide.specialization.hepatologist'),
    [EReferralGuideSpecializationDTO.Allergology]: () =>
      TranslateService.localize('referral-guide.specialization.allergologist'),

    [EReferralGuideSpecializationDTO.AllergyAndImmunology]: () =>
      TranslateService.localize('referral-guide.specialization.allergyAndImmunology'),
    [EReferralGuideSpecializationDTO.Anesthesiology]: () =>
      TranslateService.localize('referral-guide.specialization.anesthesiologist'),
    [EReferralGuideSpecializationDTO.Angiology]: () =>
      TranslateService.localize('referral-guide.specialization.angiologist'),
    [EReferralGuideSpecializationDTO.CardiovascularSurgery]: () =>
      TranslateService.localize('referral-guide.specialization.cardiovascularSurgery'),
    [EReferralGuideSpecializationDTO.HandSurgery]: () =>
      TranslateService.localize('referral-guide.specialization.handSurgery'),
    [EReferralGuideSpecializationDTO.DigestiveSystemSurgery]: () =>
      TranslateService.localize('referral-guide.specialization.digestiveSystemSurgery'),
    [EReferralGuideSpecializationDTO.OncologicSurgery]: () =>
      TranslateService.localize('referral-guide.specialization.oncologicSurgery'),
    [EReferralGuideSpecializationDTO.PediatricSurgery]: () =>
      TranslateService.localize('referral-guide.specialization.pediatricSurgery'),
    [EReferralGuideSpecializationDTO.PlasticSurgery]: () =>
      TranslateService.localize('referral-guide.specialization.plasticSurgery'),
    [EReferralGuideSpecializationDTO.ThoracicSurgery]: () =>
      TranslateService.localize('referral-guide.specialization.thoracicSurgery'),
    [EReferralGuideSpecializationDTO.Coloproctology]: () =>
      TranslateService.localize('referral-guide.specialization.coloproctology'),
    [EReferralGuideSpecializationDTO.MedicalGenetics]: () =>
      TranslateService.localize('referral-guide.specialization.medicalGenetics'),
    [EReferralGuideSpecializationDTO.Mastology]: () =>
      TranslateService.localize('referral-guide.specialization.mastology'),
    [EReferralGuideSpecializationDTO.FamilyAndCommunityMedicine]: () =>
      TranslateService.localize('referral-guide.specialization.familyAndCommunityMedicine'),
    [EReferralGuideSpecializationDTO.OccupationalMedicine]: () =>
      TranslateService.localize('referral-guide.specialization.occupationalMedicine'),
    [EReferralGuideSpecializationDTO.TrafficMedicine]: () =>
      TranslateService.localize('referral-guide.specialization.trafficMedicine'),
    [EReferralGuideSpecializationDTO.SportsMedicine]: () =>
      TranslateService.localize('referral-guide.specialization.sportsMedicine'),
    [EReferralGuideSpecializationDTO.PhysicalAndRehabilitationMedicine]: () =>
      TranslateService.localize('referral-guide.specialization.physicalAndRehabilitationMedicine'),
    [EReferralGuideSpecializationDTO.LegalAndForensicMedicine]: () =>
      TranslateService.localize('referral-guide.specialization.legalAndForensicMedicine'),
    [EReferralGuideSpecializationDTO.NuclearMedicine]: () =>
      TranslateService.localize('referral-guide.specialization.nuclearMedicine'),
    [EReferralGuideSpecializationDTO.PreventiveAndSocialMedicine]: () =>
      TranslateService.localize('referral-guide.specialization.preventiveAndSocialMedicine'),
    [EReferralGuideSpecializationDTO.Neonatology]: () =>
      TranslateService.localize('referral-guide.specialization.neonatology'),
    [EReferralGuideSpecializationDTO.Neurosurgery]: () =>
      TranslateService.localize('referral-guide.specialization.neurosurgery'),
    [EReferralGuideSpecializationDTO.Nutrology]: () =>
      TranslateService.localize('referral-guide.specialization.nutrology'),
    [EReferralGuideSpecializationDTO.ClinicalOncology]: () =>
      TranslateService.localize('referral-guide.specialization.clinicalOncology'),
    [EReferralGuideSpecializationDTO.Pathology]: () =>
      TranslateService.localize('referral-guide.specialization.pathology'),
    [EReferralGuideSpecializationDTO.ClinicalPathologyAndLaboratoryMedicine]: () =>
      TranslateService.localize('referral-guide.specialization.clinicalPathologyAndLaboratoryMedicine'),
    [EReferralGuideSpecializationDTO.Radiology]: () =>
      TranslateService.localize('referral-guide.specialization.radiology'),
    [EReferralGuideSpecializationDTO.Radiotherapy]: () =>
      TranslateService.localize('referral-guide.specialization.radiotherapy'),
    [EReferralGuideSpecializationDTO.SpeechTherapist]: () =>
      TranslateService.localize('referral-guide.specialization.speechTherapist'),
    [EReferralGuideSpecializationDTO.OccupationalTherapist]: () =>
      TranslateService.localize('referral-guide.specialization.occupationalTherapist'),
    [EReferralGuideSpecializationDTO.Nurse]: () => TranslateService.localize('referral-guide.specialization.nurse'),
    [EReferralGuideSpecializationDTO.SocialWorker]: () =>
      TranslateService.localize('referral-guide.specialization.socialWorker'),
    [EReferralGuideSpecializationDTO.Pharmacist]: () =>
      TranslateService.localize('referral-guide.specialization.pharmacist'),
    [EReferralGuideSpecializationDTO.Dentist]: () => TranslateService.localize('referral-guide.specialization.dentist'),
  };

  return map[specialization]?.();
}
